module.exports = __webpack_public_path__ + "static/media/notebookCorrect.e04a8b89.png";